import api from '../api/axios';

export interface LoginCredentials {
  phone: string;
  password: string;
}

export interface RegisterData {
  name: string;
  phone: string;
  cpf: string;
  password: string;
  email?: string;
}

export interface LoginResponse {
  token: string;
  user: {
    userId: string;
    phone: string;
    username?: string;
  };
  requiresConfirmation?: boolean;
  codeDeliveryMedium?: string;
  codeDeliveryDestination?: string;
}

export interface RegisterResponse {
  token: string;
  user: {
    userId: string;
    phone: string;
    username?: string;
  };
  requiresConfirmation?: boolean;
  codeDeliveryMedium?: string;
  codeDeliveryDestination?: string;
}

export interface ConfirmCodeData {
  phone: string;
  confirmationCode: string;
}

export interface ResendCodeData {
  phone: string;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/client/login', credentials);
    return response.data;
  }

  async register(data: RegisterData): Promise<RegisterResponse> {
    const response = await api.post<RegisterResponse>('/client/register', data);
    return response.data;
  }

  async confirmCode(data: ConfirmCodeData): Promise<void> {
    await api.post('/client/confirm', data);
  }

  async resendConfirmationCode(data: ResendCodeData): Promise<void> {
    await api.post('/client/resend-confirmation', data);
  }

  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
  }

  getToken(): string | null {
    return localStorage.getItem('authToken');
  }

  getUser(): any | null {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  setAuth(token: string, user: any) {
    localStorage.setItem('authToken', token);
    localStorage.setItem('userData', JSON.stringify(user));
  }
}

const authService = new AuthService();
export default authService;

